import { Collection } from "../../../types/sd";

/**
 * For CQA managers:
 *  - ASSIGNED_TO_ME: workitems belong to the cqa manager
 *  - IN_CQA (Remaining Cases): managers sees all the workitems for all the coders in progress for the project
 *  - CQA_COMPLETE (All Completed): managers sees all the workitems for all the coders completed for the project
 *  - CQA_APPROVED (Approved): managers sees all the workitems for all the coders approved for the project
 *
 * For CQA coders:
 *  -  IN_CQA (Assigned to Me): workitems belong to the cqa coder that are in progress
 *  -  CQA_COMPLETE (Complete): workitems belong to the cqa coder that are completed
 */

export enum WorkitemStatus {
    /** Virtual status used only in UI */
    ASSIGNED_TO_ME = 'Assigned to Me',
    IN_CQA = "IN_CQA",
    CQA_COMPLETE = "CQA_COMPLETE",
    CQA_APPROVED = "CQA_APPROVED",
    CQA_CLOSED = "CQA_CLOSED",
    CQA_AUDIT = "CQA_AUDIT",
    CQA_AUDIT_COMPLETE = "CQA_AUDIT_COMPLETE",
    CQA_TRAP_COMPLETE = "CQA_TRAP_COMPLETE",
}

export const WorkItemStatusToLabel = {
    [WorkitemStatus.IN_CQA]: "Assigned to Me",
    [WorkitemStatus.CQA_COMPLETE]: "Complete",
    [WorkitemStatus.CQA_APPROVED]: "Approved",
    [WorkitemStatus.CQA_CLOSED]: "Closed",
    [WorkitemStatus.CQA_AUDIT]: "Remaining Audits",
    [WorkitemStatus.CQA_AUDIT_COMPLETE]: "Audit Completed",
    [WorkitemStatus.CQA_TRAP_COMPLETE]: "Trap Completed",
};

export interface CollectionWithWorkItemCounts extends Collection {
    availability?: boolean;
    rubricVersionId?: number;
    workItemCounts?: {
        [WorkitemStatus.ASSIGNED_TO_ME]: number;
        [WorkitemStatus.IN_CQA]: number;
        [WorkitemStatus.CQA_COMPLETE]: number;
        [WorkitemStatus.CQA_APPROVED]: number;
        [WorkitemStatus.CQA_CLOSED]?: number;
        [WorkitemStatus.CQA_AUDIT]: number;
        [WorkitemStatus.CQA_AUDIT_COMPLETE]: number;
        [WorkitemStatus.CQA_TRAP_COMPLETE]: number;
    }
}